
const files = require.context('.', true, /\.js$/)

let api = { };

files.keys().forEach(key => {
    if (key === './index.js' ) return  
    Object.assign(api,files(key))    
})

export default api




// WEBPACK FOOTER //
// ./src/fetch/api/index.js